import './share-link.scss';

class ShareLink {
    constructor (element, options) {
        // Defaults & Settings
        const defaults = {
            initAttr: 'data-sharelink',
            ctaAttr: 'data-sharelink-target',
            copiedAttr: 'data-sharelink-copied',
            liveRegionAttr: 'data-sharelink-live-region'
        };

        this.settings = Object.assign({}, defaults, options);

        // Elements
        this.$root = element;
        this.$cta = this.$root.querySelector(`[${this.settings.ctaAttr}]`);
        this.$liveRegion = this.$root.querySelector(`[${this.settings.liveRegionAttr}]`);

        // Properties
        this.url = this.$cta?.getAttribute(this.settings.ctaAttr);
        this.liveRegionInfo = this.$liveRegion?.getAttribute(this.settings.liveRegionAttr);
    }

    initialize () {
        if (this.url !== null) {
            this.copyToClipboard();
        }
    }

    copyToClipboard () {
        this.$root.addEventListener('click', () => {
            navigator.clipboard.writeText(this.url)
                .then(() => {
                    this.$root.setAttribute(this.settings.copiedAttr, true);

                    if (this.$liveRegion && this.liveRegionInfo !== null) {
                        this.$liveRegion.textContent = this.liveRegionInfo;
                    }

                    setTimeout(() => {
                        this.$root.setAttribute(this.settings.copiedAttr, false);
                    }, 3000);
                })
                .catch(err => {
                    console.error('Error:', err);
                });
        });
    }
}

export { ShareLink };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-sharelink="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new ShareLink($root);
            $rootAPI.initialize();
        });
    }
});
